import { createSlice } from '@reduxjs/toolkit'
import { decryptText } from '../../utils/utils';

const auth = JSON.parse(decryptText(localStorage.getItem('user_auth_session')) || '{}');

const initialState = {
	User: auth.User || null,
	Token: auth.Token || null,
	ExpiresAt: auth.ExpiresAt || null,
}

const authUserSlice = createSlice({
	name: 'auth',
	initialState,
	reducers: {
		setAuthUser: (state, action) => {
			return {...state, ...action.payload};
		},
		deleteAuthUser: () => {
			return { User: {}, Token: null, ExpiresAt: null };
		}
	},
});

export const { setAuthUser, deleteAuthUser } = authUserSlice.actions;

export default authUserSlice.reducer